export default __webpack_public_path__ + "static/media/dictionary 3.326be7de.PNG";